export default __webpack_public_path__ + "static/media/buster_klein_80.9ac6db64.jpg";